module.exports = __webpack_public_path__ + "static/media/ils_gold_purchase_pending.1ef3d1e4.svg";